import * as React from 'react';

interface ColumnConfig {
  default?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  '2xl'?: number;
}

interface CardGridProps {
  children: React.ReactNode;
  className?: string;
  columns?: ColumnConfig;
}

const defaultColumns: ColumnConfig = {
  default: 2,
  sm: 3,
  lg: 4,
  xl: 5,
  '2xl': 6
};

export const CardGrid: React.FC<CardGridProps> = ({ children, className, columns = defaultColumns }) => {
  const getColumnClasses = () => {
    const classes = [];

    // Base columns (mobile)
    classes.push(`grid-cols-${columns.default || defaultColumns.default}`);

    // Responsive columns
    if (columns.sm || defaultColumns.sm) {
      classes.push(`sm:grid-cols-${columns.sm || defaultColumns.sm}`);
    }
    if (columns.md) {
      classes.push(`md:grid-cols-${columns.md}`);
    }
    if (columns.lg || defaultColumns.lg) {
      classes.push(`lg:grid-cols-${columns.lg || defaultColumns.lg}`);
    }
    if (columns.xl || defaultColumns.xl) {
      classes.push(`xl:grid-cols-${columns.xl || defaultColumns.xl}`);
    }
    if (columns['2xl'] || defaultColumns['2xl']) {
      classes.push(`2xl:grid-cols-${columns['2xl'] || defaultColumns['2xl']}`);
    }

    return classes.join(' ');
  };

  return <div className={`w-full grid gap-4 sm:gap-6 ${getColumnClasses()} ${className}`}>{children}</div>;
};
